import { configureStore } from "@reduxjs/toolkit";
import krpanoSlice from "features/krpano/details-slice";
import panoramaSlice from "features/panorama/details-slice";
import settingsSlice from "features/settings/details-slice";

export const store = configureStore({
  reducer: {
    krpano: krpanoSlice,
    panorama: panoramaSlice,
    settings: settingsSlice,
  },
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
